import styled from "@emotion/styled";
import {Flex} from "antd";

export const FullFlex = styled(Flex)`
    width: 100%;
    `
